import ItemsBookmarksLoader from './itemsBookmarksLoader'

export default ItemsBookmarksLoader
